export const et = {
    LEFT: 'Vasakul: Liikuda eelmisele päevale.',
    RIGHT: 'Õigus: Liikuda järgmisel päeval.',
    DOWN: 'Alla: Liigub järgmisele reale.',
    UP: 'Üles: Liigu eelmisele reale.',
    PGUP: 'PgUp: liikuge eelmise kuu.',
    PGDOWN: 'PgDown: Liikuda järgmise kuu jooksul.',
    HOME: 'Home: liikuge eelmise aasta.',
    END: 'Lõpp: Liikuda järgmisse aastasse.',
    ESC: 'Esc/Täna/Sulgemine: tihe kalender.',
    TITLE: 'Klaviatuuri Juhised'
};
